






















import { Component, Vue, Prop } from "vue-property-decorator";
import { ZhenciJianchaList } from "@/request/sjzx";
import JiluRender from "./jilu-render.vue";

@Component({
  components: {
    JiluRender,
  },
})
export default class JianchahenjiDialog extends Vue {
  @Prop()
  private ifVisible: any;
  @Prop()
  private zhenci: any;
  private jilus: any[] = [];
  private get visible() {
    return this.ifVisible;
  }
  private set visible(val) {
    this.$emit("update:ifVisible", val);
  }
  private cancel() {
    this.$emit("update:ifVisible", false);
  }
  /**
   * @description 获得监查记录
   */
  private getJianchaList() {
    const params: any = {
      params: {
        zhenci_id: this.zhenci.zhenci_id,
      },
    };
    ZhenciJianchaList(this, params).then((data: any) => {
      // console.log(data);
      data.forEach((item: any) => {
        item.ifShowDetail = true;
      });
      this.jilus = data;
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getJianchaList();
  }
}
